import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const PositionCreatedEventPayloadSchema = order.positionService.versions.v1.schemas.POSITION_CREATED;

export type PositionCreatedEventPayload = z.infer<typeof PositionCreatedEventPayloadSchema>;
